import { render } from "./Inquiry.vue?vue&type=template&id=214c7894&scoped=true"
import script from "./Inquiry.vue?vue&type=script&lang=js"
export * from "./Inquiry.vue?vue&type=script&lang=js"

import "./Inquiry.vue?vue&type=style&index=0&id=214c7894&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/PROD_AptokPromotion/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-214c7894"]])

export default __exports__